import React, { useEffect } from "react";
import { Fragment } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Loading from "../../Components/Common/Loading/Loading";
import BorderBox from "../../_Components/Common/BoxUI/BorderBox";
import DefaultButton from "../../_Components/Common/ButtunUI/DefaultButton";
import PageTitle from "../../_Components/Common/PageTitle/PageTitle";
import MessageQnaList from "../../_Components/MessageCenter/MessageQna/MessageQnaList";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 15px;
`;

const Inner = styled.div`
  display: flex;
`;

const ControlBox = styled.div`
  display: flex;
  width: 100%;
  margin-top: 15px;
  margin-left: 15px;
`;

const MessageQnaListPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  useEffect(() => {
    if (window.sessionStorage.getItem("token")) {
      setIsLoading(false);
    } else {
      history.push("/");
    }
  }, []);

  return (
    <Wrapper>
      <PageTitle
        mainTitle={"1:1 Message"}
        v1Link={""}
        navNames={["Management", "Message Center", "1:1 Message"]}
      />
      {isLoading && <Loading />}
      {!isLoading && (
        <Fragment>
          <ControlBox>
            <DefaultButton
              btnText={"Send Message"}
              theme={"blue"}
              onClick={() => {
                history.push("/Message/Qna/Send");
              }}
            />
          </ControlBox>
          <Inner>
            <BorderBox
              boxTitle={"1:1 Message List"}
              component={<MessageQnaList />}
            />
          </Inner>
        </Fragment>
      )}
    </Wrapper>
  );
};

export default MessageQnaListPage;
